var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ylAboutCollapse"}},[(_vm.isMobileScreen)?_c('ylAboutCollapseMobile',_vm._b({attrs:{"list":_vm.list}},'ylAboutCollapseMobile',_vm.$attrs,false)):_c('ylAboutCollapsePC',_vm._b({attrs:{"list":_vm.list}},'ylAboutCollapsePC',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }